import Axios, * as others from 'axios';
import React, { Component,useEffect,useState } from "react";
import URL from '../../Environment';
import IMGPATHS from '../../ImgPaths';

const AssetTable = () => {

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {

  const fetchData = async () => {
    // try {

      Axios.get(URL + 'api/Performance/GetAssetData').then((response) => {
        const res = response.data;
        //console.log(res);
        if (Array.isArray(response.data)) {
          setData(response.data);
        } else {
          //console.error('Response data is not an array', response.data);
          setError('Data is not in the expected array format');
        }
        setLoading(false);   

      }).catch((error) => {
        setError(error);
        setLoading(false); 

      });
  };

  // เรียกใช้งาน fetchData เมื่อค่าตัวแปร count มีการเปลี่ยนแปลง
  fetchData();

  // Cleanup function ที่จะถูกเรียกเมื่อ component ถูก unmount
  return () => {
    // ทำการคืนการทำงานที่ต้องการ (cleanup)
    //console.log('Component unmounted');
  };

  }, []);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Error: {error.message}</div>;
  }

  return (

// <div>
//       {data.map((item, index) => (
//          <a 
//          href={`../Form/Asset/${item.id}/${item.attachfile}`} 
//          target="_self" 
//          className="cws-button" 
//          style={{ color: "#0094ff", fontSize: "19px" }}
//        >
//          {item.topic}<br/>
//        </a>
       
//       ))}
      
// </div>

    <table className="tableAsset">
      <tbody>
        {data.map((item, index) => (
          <tr key={index}>
            <td style={{ textAlign: "left", backgroundColor: "#ffffff !important",border:0 }}>
              <a 
                href={`${IMGPATHS}Form/Asset/${item.id}/${item.attachfile}`} 
                target="_self" 
                className="cws-button" 
                style={{ color: "#0094ff", fontSize: "19px" }}
              >
                {item.topic}
              </a>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );

};



export default AssetTable;